<template>
    <kt-panel v-if="signatureStatus == 'success'">
        <kt-panel-body>
            <kt-row >
                <kt-col lg="6" md="6" sm="12">
                    <form @submit.prevent="submit" id="submit-form">
                        <kt-form-section class="mt-5 mb-5">
                            <div class="custom-control custom-checkbox" id="signature_status-div">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="signature_status"
                                    name="signature_status"
                                    v-model="signature.status"
                                >
                                <label class="custom-control-label" id="signature_status_label" for="signature_status">
                                    {{ $t('label.show_signature') }}
                                </label>
                            </div>
                        </kt-form-section>
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col lg="12" md="12" sm="12">
                                    <kt-form-group>
                                        <kt-form-label>
                                            {{$t('label.signature_description')}}
                                        </kt-form-label>
                                        <ckeditor :editor="editor"
                                                  v-model="signature.description"
                                                  :config="editorConfig"
                                                  tag-name="textarea"
                                        >
                                        </ckeditor>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-action>
                            <button
                                    class="btn btn-success btn-wide"
                                    type="submit"
                                    id="submit-btn"
                            >
                                {{ $t('btn.update') }}
                            </button>
                        </kt-form-action>
                    </form>
                </kt-col>
            </kt-row>
        </kt-panel-body>
    </kt-panel>
</template>

<script>

import { mapGetters } from "vuex";
import {ticketService} from "../../../common/api.service";
import { KTApp } from "@/plugins/core/app"
import $ from 'jquery'
import { i18n } from '@/plugins/i18n'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import {editorConfig} from '@/constants/ckeditorConfigs'
import { moneyRequestService } from "../../../common/api.service";

export default {
    components: {
        ckeditor: CKEditor.component
    },
    data() {
        return {
            data: null,
            editor: ClassicEditor,
            editorData: '',
            editorConfig: editorConfig
        }
    },
    computed: {
        ...mapGetters('ticket', [
            'signature',
            'signatureStatus'
        ]),
    },
    methods: {
      submit() {
          let form = $('#submit-form')
          let btn = $('#submit-btn')

          KTApp.progress(btn)

          let params = {
              description: this.signature.description,
              status: this.signature.status,
          }

          return ticketService.updateSignature(params).then(response => {
              KTApp.unprogress(btn)
              this.showMsg(form, 'success', response.data.message)
          })
          .catch(({response}) => {
              KTApp.unprogress(btn)
              this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
          })
      }
    },
    mounted() {
        this.$store.dispatch('ticket/fetchSignature')
    }

}
</script>